var map = {
	"./en.json": [
		1681,
		63
	],
	"./et.json": [
		1682,
		62
	],
	"./fi.json": [
		1683,
		61
	],
	"./lv.json": [
		1684,
		60
	],
	"./pl.json": [
		1685,
		59
	],
	"./ru.json": [
		1686,
		58
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1678;


//////////////////
// WEBPACK FOOTER
// ./src/i18n lazy ^\.\/.*\.json$
// module id = 1678
// module chunks = 65